<div class="w-full py-3 px-4">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      </div>

    <div>
      <a
        routerLink="/invoice/add"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]"
      >
        Add New Invoice
      </a>
    </div>
  </div>

  <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-1 sm:gap-2">

    <div class="flex items-center justify-center md:justify-start gap-1 sm:gap-2">
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label
          for="rowFilter"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Rows :
        </label>
        <select
          id="rowFilter"
          [(ngModel)]="itemsPerPage"
          (change)="onPageChange(1)"
          class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725"
        >
          <option
            *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]"
            [value]="count"
          >
            {{ count }}
          </option>
        </select>
        <div
          class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none"
        >
          <svg
            width="10"
            height="5"
            viewBox="0 0 14 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
              fill="#C19725"
            />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label
          for="globalSearch"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Search :
        </label>
        <input
          id="globalSearch"
          type="text"
          [(ngModel)]="globalSearchText"
          (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off"
        />
      </div>
    </div>

    <div
      class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2"
    >
      <button
        class="text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()"
      >
         PDF
      </button>
      <button
        class="text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()"
      >
        Excel
      </button>
      <button
        class="text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()"
      >
        JSON
      </button>
      <button
        class="text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()"
      >
         CSV
      </button>

      <div class="relative inline-block text-left">
        <button
          (click)="toggleDropdown()"
          class="text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        >
          Column Visibility
        </button>

        <div
          *ngIf="showDropdown"
          class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64"
        >
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <label
            *ngFor="let field of selectedFields"
            class="block text-sm mb-1"
          >
            <input
              type="checkbox"
              [(ngModel)]="field.selected"
              autocomplete="off"
            />
            {{ field.label }}
          </label>

          <div class="mt-3 flex flex-col gap-2">
            <button
              (click)="selectAllFields()"
              class="text-sm text-blue-600 hover:underline text-left"
            >
              Select All
            </button>
            <button
              (click)="deselectAllFields()"
              class="text-sm text-red-800 hover:underline text-left"
            >
              Deselect All
            </button>
            <button
              (click)="restoreColumnSelection()"
              class="text-sm text-gray-600 hover:underline text-left"
            >
              Restore Columns
            </button>

            <button
              (click)="applyColumnSelection()"
              class="mt-2 bg-c19725 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] transition"
            >
              Apply
            </button>
          </div>
        </div>
      </div>

      <button
        (click)="printTable()"
        class="text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
      >
        Print
      </button>
    </div>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">No.</th>

          <th
            *ngFor="let field of visibleFields"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0"
          >
            <div class="flex flex-col gap-1 w-32">
              <input
                type="text"
                [(ngModel)]="searchValues[field.key]"
                (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()"
                [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full"
                autocomplete="off"
              />

              <div
                class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg
                  *ngIf="sortKey === field.key"
                  class="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path
                    *ngIf="sortDirection === 'asc'"
                    d="M12 8l6 6H6z"
                    fill="currentColor"
                  />
                  <path
                    *ngIf="sortDirection === 'desc'"
                    d="M12 16l-6-6h12z"
                    fill="currentColor"
                  />
                </svg>
              </div>

            </div>
          </th>

          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">Action</th>
        </tr>
      </thead>

      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let item of paginatedInvoiceList; let i = index">

          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <td
            *ngFor="let field of visibleFields"
            class="p-2 border-r border-b border-[#D9D9D9]"
          >
            {{ formatFieldValue(item, field) }}
          </td>

          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            <div class="flex items-center justify-center gap-1 sm:gap-2">
              <button
                aria-label="View Invoice Details"
                class="icon-btn text-blue-600 hover:scale-110 hover:text-blue-800"
                (click)="openInvoiceDetails(item.id)"
                title="View Details"
              >
                <svg
                  class="w-5 h-5 md:w-6 md:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4.5C7.305 4.5 3.133 8.118 1.5 12c1.633 3.882 5.805 7.5 10.5 7.5s8.867-3.618 10.5-7.5c-1.633-3.882-5.805-7.5-10.5-7.5z"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
              </button>

              <button
                class="cursor-pointer text-red-500 hover:text-red-700 hover:scale-110 transition-transform"
                (click)="deleteInvoice(item.id, item.invoice_number)"
                title="Delete Invoice"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 6H5H21M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <!-- <button
                class="cursor-pointer"
                (click)="router.navigate(['/invoice/edit', item.id])"
                title="Edit"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.7166 9.23962L8.10638 15.8499"
                    stroke="#C19725"
                    stroke-miterlimit="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button> -->

              </div>
          </td>

        </tr>
        <tr *ngIf="paginatedInvoiceList.length === 0">
          <td [attr.colspan]="visibleFields.length + 2" class="p-4 text-center text-gray-500 border-b border-[#D9D9D9]">
            No invoices found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex items-center justify-end border-t border-gray-200 bg-white py-3">
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav
          class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs"
          aria-label="Pagination"
        >
          <button
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <ng-container *ngFor="let page of pageNumbers">
            <button
              *ngIf="page === 1 || page === totalPages || (page >= currentPage - 1 && page <= currentPage + 1)"
              (click)="onPageChange(page)"
              [class.bg-c19725]="currentPage === page"
              [class.text-white]="currentPage === page"
              class="relative z-10 inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
              [ngClass]="{'bg-c19725 text-white': currentPage === page, 'text-c19725 bg-white': currentPage !== page}"
            >
              {{ page }}
            </button>
            <span
              *ngIf="page === 2 && currentPage > 3"
              class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
              >...</span
            >
             <span
              *ngIf="page === totalPages - 1 && currentPage < totalPages - 2"
              class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
              >...</span
            >
          </ng-container>

          <button
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="sr-only">Next</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>
